import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/WhatsApp_Glyph_White.svg")